// Actions that end the bot's part of the flow (the conversation is handed
// off or closed) — their node has no outgoing connections.
export const TERMINAL_ACTIONS = new Set(['transfer_agent', 'close_conversation', 'transferToAgent'])

export function isTerminalAction(action: string | null | undefined): boolean {
  return Boolean(action) && TERMINAL_ACTIONS.has(action as string)
}

interface NodeLinks {
  action?: string | null
  nextNodeId?: string | null
  fallbackNodeId?: string | null
}

// Drops the links a terminal node can't have — flows saved before
// transferToAgent became terminal may still carry a nextNodeId.
export function withoutTerminalLinks<T extends NodeLinks>(data: T): T {
  if (!isTerminalAction(data.action)) return data
  return { ...data, nextNodeId: null, fallbackNodeId: null }
}
